import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { LoginResponse } from "@core/models/api.response";
import { userCredentialsDTO } from "@core/models/dto.models";

@Injectable({
  providedIn: "root",
})
export class LoginService {
  constructor(private http: HttpClient) {}

  login(credentials: userCredentialsDTO): Observable<LoginResponse> {
    return this.http
      .post<LoginResponse>(`${environment.apiUri}/auth/login`, {
        email: credentials.email,
        password: credentials.password,
      })
      .pipe(
        catchError((error) => {
          return throwError(
            () =>
              new Error(
                error.error?.message ??
                  error.message ??
                  "An Unknown error has occured, please try again."
              )
          );
        })
      );
  }
}
